<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint - Verification</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="ccv.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <!-- <input type="text" class="form-control" id="reported-date" v-model="ccv.reportedDate" disabled> -->
                <flat-pickr class="form-control" id="reported-date" v-model="ccv.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <input type="text" class="form-control" id="distributed-internal" v-model="ccv.distributedToInternal" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Complaint Received Date</label>
                <flat-pickr class="form-control" id="reported-date" v-model="ccv.receivedDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <input type="text" class="form-control" id="customer" v-model="ccv.customerName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Brand</label>
                <input type="text" class="form-control" id="brand" v-model="ccv.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="product" v-model="ccv.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="plant" v-model="ccv.plantName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="address" v-model="ccv.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="ccv.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" id="email" v-model="ccv.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="ccv.phone" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <!-- <input type="text" class="form-control" id="bl-date" v-model="ccv.blDate" disabled> -->
                <flat-pickr class="form-control" id="bl-date" v-model="ccv.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <!-- <input type="text" class="form-control" id="dispatch-date" v-model="ccv.dispatchDate" disabled> -->
                <flat-pickr class="form-control" id="dispatch-date" v-model="ccv.dispatchDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="ccv.containerNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="packaging" v-model="ccv.packagingName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="ccv.dischargePortName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="country" v-model="ccv.countryName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="ccv.modelOfDeliveryName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Non Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="ccv.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="ccv.complaintMediaName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="ccv.enclosedName" disabled>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="description" v-model="ccv.description" rows="3" disabled></textarea>
            </div>
        </div>
        Customer Complaint Detail
        <app-datatable :type="'view'" :elements="dtElementsDetail" :collections="ccv.customerComplaintDetail"></app-datatable>
        <br /><br />
        Investigation Data
        <app-datatable :type="'view'" :elements="dtElements" :collections="ccv.detail" v-on:selectedRow="selectRow"></app-datatable>
        <br /><br />
        Root Cause Analysys & Corrective and Preventive Action Internal Data
        <app-datatable :type="'view'" :elements="dtElementsCorrectivePreventiveInternal" :collections="ccv.correctivePreventiveInternal"></app-datatable>
        <br /><br />
        <!-- Corrective External Data
        <app-datatable :type="'view'" :elements="dtElementsExternal" :collections="ccv.correctiveExternal"></app-datatable>
        <br /><br /> -->
        <div class="row">
            <div class="form-group col-4">
              <label for="owner-member">Owner Area</label>
              <input type="text" class="form-control" id="owner-name" v-model="ccv.ownerMemberName" disabled>
            </div>
            <div class="form-group col-4">
              <label for="owner-member">Owner Email</label>
              <input type="text" class="form-control" id="owner-email" v-model="ccv.ownerMemberEmail" disabled>
            </div>
            <div class="form-group col-4">
              <label for="owner-member">Head Of Department</label>
              <input type="text" class="form-control" id="owner-email" v-model="ccv.hodName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
              <label for="action">Action</label>
              <select type = "dropdown" class="form-control" id="action" v-model="ccv.action">
                <option v-for="(list, index) in this.actionLists" :key="index" :value="list.value">{{ list.title }}</option>
              </select>
            </div>
            <div class="form-group col-6">
              <label for="comment">Comment</label>
              <textarea class="form-control" id="comment" v-model="ccv.comment" rows="3"></textarea>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintVerification, correctiveExternal, correctivePreventiveInternal, customerComplaintDetail, customerComplaintVerificationDetail } from '../../models/customerComplaintVerification'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          ccv: {...customerComplaintVerification, customerComplaintDetail: [], detail: [],
                correctiveExternal: [], correctivePreventiveInternal: []},
          newDetail: customerComplaintVerificationDetail,
          newCustomerComplaintDetail: customerComplaintDetail,
          selectedId: '',
          dtElementsDetail: [
                {
                    title: 'PO',
                    column: 'po',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'SO',
                    column: 'so',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Batch',
                    column: 'batch',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'text',
                    width: 6,
                },
          ],
          dtElements: [
            {
              title: 'Question',
              column: 'question',
              type: 'text'
            },
            {
              title: 'Responder',
              column: 'responder',
              type: 'text'
            },
            {
              title: 'Email',
              column: 'email',
              type: 'text'
            },
            {
              title: 'Answer',
              column: 'answer',
              type: 'text'
            },
            {
                title: 'Attachment',
                column: 'attachment',
                type: 'link'
              },
            {
              title: 'Answered At',
              column: 'answeredAt',
              type: 'date'
            },
          ],
          actionLists: [
                {
                    title: 'Valid',
                    value: 'valid'
                },
                {
                    title: 'Invalid',
                    value: 'invalid'
                },
                {
                    title: 'Feedback',
                    value: 'feedback'
                }
          ],
          dtElementsExternal: [
            {
                title: 'Investigation Detail',
                column: 'investigationDetail',
                type: 'text',
                width: 8,
            },
            {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 8,
            },
            {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsCorrectivePreventiveInternal: [
              {
                title: 'Action No.',
                column: 'actionNo',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Root Cause Remark',
                column: 'rootCauseRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Type',
                column: 'actionType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Remark',
                column: 'actionRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Work Description',
                column: 'workDescription',
                type: 'text',
                width: 6,
              },
              {
                title: 'Evidence',
                column: 'evidence',
                type: 'link',
                width: 6,
              },
              {
                title: 'Responder Name',
                column: 'picName',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Target Date',
                column: 'targetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const cciApi = api('customer-complaint-verification')
            this.ccv = await cciApi.getWithParams(this.$route.query.id)

            console.log(this.ccv.correctiveExternal)
        }
    },
    methods: {
        async save() {
            const cciApi = api('customer-complaint-verification')
            if(this.$route.query.id !== undefined) {
                await cciApi.update(this.ccv, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.go(-1)
        },
        selectRow(id) {
          this.selectedId = id
        },
        finishLookup(data) {
            const currentCcs = this.ccv
            this.ccv = {
                ...currentCcs,
                ...data
            }
        }
    }
}
</script>